module.exports = __webpack_public_path__ + "07231bc69618323e334495f8e390947f.png";